import React from 'react'
import StrapiComponents from '@/components/StrapiComponents'
import { StSponsors } from './style.css'

const Sponsors = ({ data, className, childClassName }) => {
  if (!data) return
  return (
    <StSponsors className={`${className}`}>
      {data.map((component, index) => (
        <StrapiComponents
          key={index}
          component={component}
          className={childClassName}
        />
      ))}
    </StSponsors>
  )
}

export default Sponsors
